import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { getEngageConfiguration } from 'api/engage';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { accountQueryKeys } from 'queries/account-query-keys';
import { EngageConfiguration } from 'types/domain';

interface Options
    extends Omit<
        UseSuspenseQueryOptions<EngageConfiguration, DefaultError, EngageConfiguration, any>,
        'queryKey'
    > {}

const useEngageConfig = (options: Options = {} as Options) => {
    const { accountId } = useCurrentAccount();
    const {
        engageSms = false,
        engageMessageTemplates = false,
        engageSmsKeywords = false,
    } = useFlags();
    const { data: engageConfig } = useSuspenseQuery({
        queryKey: accountQueryKeys.engageConfiguration(accountId),
        queryFn: () => getEngageConfiguration(accountId),
        ...options,
    });

    return {
        engageConfig,
        hasEngageMessageTemplates: engageMessageTemplates,
        hasSMSKeywords: engageSmsKeywords,
    };
};

export { useEngageConfig };
